module.exports = __webpack_public_path__ + "static/img/zhenda.1bdd0fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhenda.jpg
// module id = apJt
// module chunks = 0